import { SessionType } from './model'

export const colorFromResult = (s: string | null): string => {
  switch (s) {
    case 'success':
      return 'text-success'
    case 'failure':
      return 'text-danger'
    default:
      return 'base'
  }
}

export const colorFromStatus = (s: string | null): string => {
  switch (s) {
    case 'completed':
      return 'text-success'
    default:
      return 'base'
  }
}

export function sessionTypeToLabel(st: SessionType): string {
  switch (st) {
    case 'posaas_menu_sync':
      return 'POS Menu Sync'
    case 'posaas_order_push':
      return 'POS Order Push'
    default:
      return st
  }
}
